import { css, styled } from 'styled-components';

import { Media } from '../../../../../theme/Media.tsx';
import { CELL_PADDING_COMPACT, CELL_PADDING_DEFAULT, MOBILE_PADDING } from '../../constants.ts';
import { actionCellStyles, checkboxCellStyles, dndCellStyles } from '../../mixins.ts';
import { TableCellContentType } from '../../types.ts';

interface SubRowsContainerProps {
  $compact: boolean;
  $isInteractive: boolean | undefined;
}

export const SubRowsContainer = styled.div<SubRowsContainerProps>`
  grid-column: 1 / -1;
  grid-row: 2;
  display: grid;
  grid-template-columns: subgrid;
  background: ${({ theme }) => theme.colors.grey00_1};

  ${({ $isInteractive }) =>
    $isInteractive &&
    css`
      cursor: pointer;
    `}

  @media ${Media.xsMax} {
    display: block;
    border-top: 1px solid ${({ theme }) => theme.colors.grey10_1};
    -webkit-tap-highlight-color: transparent;
  }
`;

interface SubRowWrapperProps {
  $compact: boolean;
}

export const SubRowWrapper = styled.div<SubRowWrapperProps>`
  display: grid;
  grid-template-columns: subgrid;
  grid-column: 1 / -1;
  overflow: clip;
  background: inherit;

  @media ${Media.xsMax} {
    display: block;
  }
`;

interface SubRowContentProps {
  $compact: boolean;
  $colSpan: number;
}

export const SubRowContent = styled.div<SubRowContentProps>`
  padding: ${({ $compact }) => ($compact ? CELL_PADDING_COMPACT : CELL_PADDING_DEFAULT)};
  grid-column: span ${({ $colSpan }) => $colSpan};

  @media ${Media.xsMax} {
    padding: ${MOBILE_PADDING};
  }
`;

interface SubRowPlaceholderProps {
  $contentType: TableCellContentType;
  $compact: boolean;
}

export const SubRowPlaceholder = styled.div<SubRowPlaceholderProps>`
  @media ${Media.smMin} {
    ${({ $contentType, $compact }) => $contentType === TableCellContentType.DND && dndCellStyles($compact)}
    ${({ $contentType, $compact }) => $contentType === TableCellContentType.CHECKBOX && checkboxCellStyles($compact)}
    ${({ $contentType, $compact }) => $contentType === TableCellContentType.ACTION && actionCellStyles($compact)}
  }

  @media ${Media.xsMax} {
    display: none;
  }
`;
